<template>
  <div class="order-list">
    <van-nav-bar
      title="发票申请"
      left-arrow
      @click-left="$router.back()"
      :right-text="data && data.length > 0 ? '新增抬头' : ''"
      @click-right="handleAddInvoiceInfo"
    />
    <van-address-list
      v-model="selectedInvoiceInfoId"
      :list="data"
      default-tag-text="默认"
      @edit="handleModifyInvoiceInfo"
    />

    <template v-if="showAddNewBtn">
      <van-col :span="22" :offset="1">
        <base-button size="large" type="danger" :round="true" @click="handleAddInvoiceInfo">
          新增抬头
        </base-button>
      </van-col>
      <van-col :span="24" style="text-align: center; color: #c3c3c3">
        <br>
        <span>请您先完善开票抬头信息，再操作发票申请！</span>
      </van-col>
    </template>

    <van-submit-bar :loading="loading" :price="totalAmount * 100" button-text="确认开票" @submit="handleConfirmInvoice" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getMemberInvoiceList, addInvoice } from '@/api/wx-fwh'
export default {
  name: 'WxApplyInvoice',
  data() {
    return {
      loading: false,
      data: [],
      selectedInvoiceInfoId: 1,
      selectedOrderList: null,
      totalAmount: 0,
      showAddNewBtn: false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    const data = localStorage.getItem('selectedOrderList')
    if (data) {
      this.selectedOrderList = JSON.parse(data)
      let totalAmount = 0
      this.selectedOrderList.forEach(order => {
        totalAmount += parseFloat(parseFloat(order.receivable_amount || 0).toFixed(2))
      })
      totalAmount = parseFloat(totalAmount.toFixed(this.CONST.DECIMAL.DEFAULT_PRECISION))
      this.totalAmount = totalAmount
    } else {
      this.error('请您选择需要申请发票的订单')
      this.$router.back()
    }
    this.query()
  },
  methods: {
    handleAddInvoiceInfo() {
      this.$router.push('/wx-edit-invoice-info')
    },
    handleConfirmInvoice() {
      if (this.selectedOrderList && this.selectedOrderList.length > 0) {
        this.loading = true
        const invoiceInfo = this.data.find(invoiceInfo => invoiceInfo.id === this.selectedInvoiceInfoId)
        if (invoiceInfo) {
          const sell_invoices = []
          this.selectedOrderList.forEach(order => {
            sell_invoices.push({
              sell_id: order.id,
              invoice_amount: parseFloat(parseFloat(order.receivable_amount || 0).toFixed(2))
            })
          })
          addInvoice({
            sell_invoices: sell_invoices,
            inv_type: this.CONST.INVOICE_TYPE.find(type => type.name === '电子发票').id,
            company: this.CONST.INVOICE_COMPANY.find(company => company.name === '汇力发').id,
            type: invoiceInfo.type,
            payer: invoiceInfo.payer,
            tax_num: invoiceInfo.tax_num,
            amount: this.totalAmount,
            mobile: invoiceInfo.mobile,
            email: invoiceInfo.email
          }).then(resp => {
            this.loading = false
            if (resp.success) {
              localStorage.removeItem('selectedOrderList')
              this.alert('发票申请成功')
              this.$router.push({
                name: 'WxOrderList',
                params: { active: 1 }
              })
            } else {
              this.alert(resp.msg)
            }
          }).catch(error => {
            this.loading = false
          })
        } else {
          this.alert('请您先选择开票抬头信息')
          this.loading = false
        }
      } else {
        this.$router.push('/wx-order-list')
      }
    },
    handleModifyInvoiceInfo(item) {
      localStorage.setItem('selectedInvoiceInfo', JSON.stringify(item))
      this.$router.push('/wx-edit-invoice-info')
    },
    query() {
      getMemberInvoiceList({
        member_id: this.userInfo.id
      }).then(resp => {
        this.data = resp.rows || []
        this.data.forEach((row, index) => {
          row.name = row.payer
          row.tel = row.tax_num || row.mobile
          row.address = '发票类型：' + this.CONST.MEMBER_INVOICE_TYPE.find(type => type.id === row.type).name
          row.isDefault = row.is_default === 1
          if (row.isDefault) {
            this.selectedInvoiceInfoId = index + 1
          }
        })
        if (this.data.length === 0) {
          this.showAddNewBtn = true
        } else {
          this.showAddNewBtn = false
        }
      })
    }
  }
}
</script>

<style scoped>
  .order-list {
    color: #323233;
    font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue',
      Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
  }
  .van-address-list__bottom {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/wxfwh/apply-invoice/wx-apply-invoice.vue